module.exports = __webpack_public_path__ + "img/Y2404.c51e136c.jpeg";